import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AcaoBtnTabelaEnum } from './table-cadastro.enum';
import { BaseComponent } from '../base/base.component';
import { BaseSharedService } from '../base-shared/base-shared.service';
import { StatusEnum } from '@core/action/action';
import { AbstractControl, FormGroup } from '@angular/forms';
import { PermissaoEnum } from '@core/auth/objeto.enum';
import { PerfilEnum } from '@core/auth/permissoes-acesso';

export { AcaoBtnTabelaEnum } from './table-cadastro.enum';

@Component({
  selector: 'app-table-cadastro',
  templateUrl: './table-cadastro.component.html',
  styleUrls: ['./table-cadastro.component.scss']
})
export class TableCadastroComponent extends BaseComponent implements OnInit, AfterViewInit {

  @Output() tabelaItemInativarEvent = new EventEmitter<any>();
  @Output() tabelaItemDeletarEvent = new EventEmitter<any>();
  @Output() tabelaItemAtivarEvent = new EventEmitter<any>();
  @Output() tabelaItemReenvioEmailAtivacaoEvent = new EventEmitter<any>();
  @Input() nomeItem!: string;
  @Input() colunas: any[] = [];
  @Input() columnKeys: any[] = [];
  @Input() acaoBtn: any;
  @Input() service: any;
  @Input() rotaEditar!: string;
  @Input() rotaVisualizar!: string;
  @Input() esconderEditar: boolean = false;
  @Input() esconderVisualizar: boolean = true;
  @Input() esconderInativar: boolean = false;
  @Input() mostrarExclusaoSecundario: boolean = false;
  @Input() form!: FormGroup;

  permissaoEnum = PermissaoEnum;
  perfilEnum = PerfilEnum;
  public isSmallScreen: boolean = false;

  constructor(baseSharedService: BaseSharedService) {
    super(baseSharedService)
  }

  ngOnInit(): void {
    (this.form)
      ? this.consultarList(this.form, this.service)
      : this.consultarList(undefined, this.service);

    this.checkScreenSize();
  }

  ngAfterViewInit(): void {
    const sub = this.appSharedDataService.buscar$.subscribe(form => {
      if (!this.isFormularioVazio(form)) {
        this.consultarList(form, this.service)
      }
    })
    this.subscription.add(sub);

    const sub2 = this.appSharedDataService.resetar$.subscribe(res => {
      if (res) {
        this.consultarList(undefined, this.service)
      }
    });
    this.subscription.add(sub2);
  }

  buscarDados(reset: boolean = false): void {
    this.searchList(this.service, reset);
  }

  edit(id: number) {
    (this.rotaEditar)
      ? this.router.navigate([this.rotaEditar, id])
      : this.router.navigate(['cadastro', this.nomeItem, 'editar', id]);
  }

  delete(item: any) {
    (this.acaoBtn === AcaoBtnTabelaEnum.Deletar)
      ? this.tabelaItemDeletarEvent.emit(item)
      : this.tabelaItemInativarEvent.emit(item);
  }

  visualizarItem(id: number) {
    (this.rotaVisualizar)
      ? this.router.navigate([this.rotaVisualizar, id])
      : this.router.navigate(['cadastro', this.nomeItem, 'visualizar', id]);
  }

  active(item: any) {
    this.tabelaItemAtivarEvent.emit(item)
  }

  reenviarEmailAtivacao(item: any) {
    this.tabelaItemReenvioEmailAtivacaoEvent.emit(item)
  }

  isAtivarInativarDeletarBtn(item: any) {
    if (this.nomeItem === 'Usuario') {
      return this.isStatusUsuarioAlteravel(item);
    }

    if (this.acaoBtn) {
      
      if (item.ativo || item.ativo == false || this.nomeItem === 'cena' && item?.statusCena?.id === StatusCenaEnum.DECUPADA) {
        return true;
      }
    }
    
    return false;
  }

  acaoAtivarInativarDeletarBtn(item: any) {
    if (this.nomeItem === 'Usuario' && this.isUsuarioInativo(item)) {
      this.active(item);
    } else if (item?.ativo || item?.statusFigurante || item?.status || item.statusCena?.id === StatusCenaEnum.DECUPADA) {
      this.delete(item);
    } else {
      this.active(item);
    }
  }

  acaoDeletarBtn(item: any) {
    this.tabelaItemDeletarEvent.emit(item)
  }

  textoAtivarInativarDeletarBtn(item: any) {
    if (this.nomeItem === 'Usuario') {
      return this.isUsuarioInativo(item) ? 'Ativar' : 'Inativar';
    }

    if (item?.ativo || item?.statusFigurante || item?.status || item?.statusCena) {
      let text;
      if (this.acaoBtn === AcaoBtnTabelaEnum.Deletar) {
        text = 'Deletar';
      }
      if (this.acaoBtn === AcaoBtnTabelaEnum.Inativar) {
        text = 'Inativar'
      }
      return text;
    } else {
      return 'Ativar'
    }
  }

  iconeAtivarInativarDeletarBtn(item: any) {
    if (this.nomeItem === 'Usuario') {
      return this.isUsuarioInativo(item) ? 'iconamoon--eye-off-light' : 'ph--eye';
    }

    if (item?.ativo || item?.statusFigurante || item?.status) {
      let icon;

      if (this.acaoBtn === AcaoBtnTabelaEnum.Deletar) {
        icon = 'material-symbols--delete-outline';
      }

      if (this.acaoBtn === AcaoBtnTabelaEnum.Inativar) {
        icon = 'ph--eye';
      }

      return icon;
    } else {
      return this.acaoBtn === AcaoBtnTabelaEnum.Deletar ? 'material-symbols--delete-outline' : 'iconamoon--eye-off-light';
    }
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && !Array.isArray(value);
  }

  colorFn(status: string) {
    switch (status) {
      case StatusEnum.Aprovado:
        return 'text-success';
      case StatusEnum.Cancelado:
        return 'text-warning';
      case StatusEnum.Pendente:
      default:
        return 'text-danger';
    }
  }

  isFormularioVazio(form: FormGroup): boolean {
    for (const controlName in form.controls) {
      if (form.controls.hasOwnProperty(controlName)) {
        const control: AbstractControl = form.controls[controlName];
        if (control.value) {
          return false;
        }
      }
    }
    return true;
  }

  isBoolean(data: any): boolean {
    return typeof data === 'boolean';
  }

  isDataCadastro(data: any, key: string): boolean {
    const stringDatas = ['dataCadastro', 'dataInicio', 'dataFim', 'dataGravacao'];

    if (stringDatas.includes(key)) {
      return true;
    }

    return typeof data === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(data);
  }

  mostrarExclusaoSecundarioFn() {
    return this.mostrarExclusaoSecundario
  }

  isStatusUsuarioAlteravel(item: any): boolean {
    const status = this.normalizarStatusUsuario(item);
    return status === 'APROVADO' || status === 'INATIVO';
  }

  isUsuarioInativo(item: any): boolean {
    return this.normalizarStatusUsuario(item) === 'INATIVO';
  }

  private normalizarStatusUsuario(item: any): string {
    return (item?.status?.descricao ?? item?.status ?? '').toString().trim().toLocaleUpperCase();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 1366; 
  }
}

export enum StatusCenaEnum {
  DECUPADA = 1,
}
